var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroundtruthLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84481 12.8126H8.29281V8.71658H12.8528C12.4432 11.7758 10.3408 15.2974 7.47201 18.875C4.33121 14.915 2.12001 11.0094 2.12001 7.73258C2.12001 4.75658 4.46881 2.29738 7.47201 2.29738C9.52001 2.29738 11.1856 3.36138 12.1424 4.97418L13.4528 4.18218C12.2512 2.10698 10.0672 0.794983 7.47201 0.794983C3.64961 0.794983 0.536011 3.88138 0.536011 7.73098C0.536011 11.5806 3.40321 16.4974 7.47201 21.195C11.5408 16.4974 14.408 11.6638 14.408 7.73098V7.26698H6.84321V12.811L6.84481 12.8126Z",
    fill: "#151E24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundtruthLogoSmall);
export default __webpack_public_path__ + "static/media/groundtruth-logo-small.41a54ab0fdf469549707d376f5779fbe.svg";
export { ForwardRef as ReactComponent };